export default __webpack_public_path__ + "static/media/star_2.a830ce80.svg";